let data5 =[
    {
        id:0,
        title:"CONTACT US",
        con1:"demo store United States.",
        con2:"0123-456-789",
        con3:"demo@demo.com"
    },
    {
        id:1,
        title:"PRODUCTS",
        con1:"Featured Product",
        con2:"Bestseller Products",
        con3:"Latest Productss",
        con4:"Special Products",
        con5:"Toprated Products"
    },
    {
        id:2,
        title:"SERVICE",
        con1:"About Us",
        con2:"Contact",
        con3:"Information",
        con4:"Privacy & Policy",
        con5:"Terms & Conditions"
    },
    {
        id:3,
        title:"EXTRA",
        con1:"Search",
        con2:"News",
        con3:"All Collections",
     
    }]

    export default data5;